<template>
  <b-modal
    id="verify-vote-modal"
    centered
    v-bind="{ ...$attrs, ...$props }"
    auto-focus
    aria-labelledby="verify-vote-modal-title"
    role="dialog"
    aria-modal="true"
    v-on="$listeners"
  >
    <template #modal-title>
      <h5 id="verify-vote-modal-title" v-translate>Verify your vote</h5>
    </template>

    <template #default>
      <div role="dialog" aria-labelledby="vote-verify-title" aria-describedby="vote-verify-desc">
        <p id="vote-verify-title" v-translate>You have to verify your vote</p>
        <p id="vote-verify-desc" v-translate>
          We sent you an e-mail to the given address which contains a verification link. With clicking on this link your
          vote will be counted.
        </p>
      </div>
      <div role="alert" aria-labelledby="verify-vote-more-info" aria-describedby="verify-vote-more-info-additional">
        <SfAlert variant="warning" icon="exclamation-triangle" iconWeight="fal" show>
          <translate id="verify-vote-more-info">
            Your vote will only count if you clicked on the verification link.
          </translate>
          <br /><br />
          <translate id="verify-vote-more-info-additional"> Got no e-mail? Please check your spam folder. </translate>
        </SfAlert>
      </div>
    </template>

    <template #modal-footer="{ close }">
      <b-button id="close-delete-modal-btn" variant="default" class="mr-1" @click="close">
        <translate>Close</translate>
      </b-button>
    </template>
  </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

import SfAlert from '@/components/SfAlert.vue'

@Component({
  name: 'verify-vote-modal',
  components: {
    SfAlert,
  },
})
export default class VerifyVoteModal extends Vue {}
</script>
